<template>
  <div id="page-top">
    <nav class="navbar navbar-expand-lg fixed-top py-2" id="mainNav">
      <div class="container-fluid">
        <a class="navbar-brand js-scroll-trigger color-primary" href="#page-top">
          <img src="img/portal/ic_logo_resimple.svg" style="width:100%" class="mr-2" />
          <span style="font-weight:bold;">DINERO EN TU CELULAR</span>
        </a>

        <button
          class="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="toggleNavBar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" :class="navBarClass" id="navbarResponsive">
          <ul class="navbar-nav ml-auto my-2 my-lg-0">
            <li class="nav-item link-accesos">
              <a class="nav-link js-scroll-trigger" href="#about">Billetera virtual</a>
            </li>
            <li class="nav-item link-accesos">
              <a class="nav-link js-scroll-trigger" href="#about">Tarjeta Prepaga</a>
            </li>
            <li class="nav-item link-accesos">
              <!-- <a
                class="nav-link js-scroll-trigger"
                href="https://www.resimple.com.ar/faq/"
              >Preguntas Frecuentes</a> -->
              <a
                class="nav-link js-scroll-trigger"
              >Preguntas Frecuentes</a>
            </li>
            <li class="nav-item link-comerciante">
              <a
                class="nav-link btn btn-transparent-primary btn-white-primary"
                href="https://www.resimple.com.ar/registro"
              >Registrarme</a>
            </li>
            <li class="nav-item">
              <a class="nav-link btn btn-primary" href="https://www.resimple.com.ar/login">Ingresar</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <router-view></router-view>

    <!-- <section class="contacto py-2 py-lg-5">
      <div class="container my-5">
        <div class="row">
          <div class="col-lg-5 text-center text-lg-left">
            <h1 class="nunito my-3">
              <img src="img/portal/ic_cierre_logo.svg" /> es resimple
            </h1>
            <h3 class="nunito my-3">
              <br />Descargá la app y creá tu billetera ahora para disfrutar de todos los beneficios.
            </h3>

            <div class="stores">
              <a
                href="https://apps.apple.com/us/app/resimple/id1454559002"
                class="mx-2"
                target="_BLANK"
              >
                <img src="img/portal/ic_store_apple.svg" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=ar.com.resimple.app"
                class="mx-2"
                target="_BLANK"
              >
                <img src="img/portal/ic_store_google.svg" />
              </a>
            </div>
          </div>
          <div class="col-lg-6 offset-sm-1 text-center text-lg-left">
            <h1 class="nunito mb-4 mt-4 mt-lg-0">Hacenos llegar tu consulta</h1>
            <form>
              <input
                type="text"
                class="form-control"
                placeholder="Nombre y Apellido"
                v-model="Name"                
              />

              <KitsCombo
                v-model="MotivoID"
                v-bind:items="motivos"
                :cleanDefault="true"
                propertyName="Name"
                propertyID="EntityID"
                :todos="true"
                id="selectMotivos"
                nullText="Seleccione motivo"
              ></KitsCombo>

              <input type="email" class="form-control" placeholder="Ingrese Email" v-model="Mail" />
              <textarea class="form-control" placeholder="Ingrese Mensaje" rows="6" v-model="Body"></textarea>

              <button type="button" class="btn float-right" @click="enviarContacto" id="contacto">Enviar Contacto</button>
            </form>
          </div>
        </div>

        <div class="row fs-08 mt-5 mb-2 py-4 border-bottom">
          <div class="col-sm-6 text-center text-lg-left">
            <img src="img/portal/ic_logo_footer_rs.svg" class="mr-2 logo" />
          </div>
          <div class="col-sm-6 text-right">
            Seguinos:
            <a href="https://www.facebook.com/resimple.ar/" class="mx-2" target="_BLANK">
              <img src="img/portal/ic_sm_facebook.svg" />
            </a>
            <a href="https://www.instagram.com/resimple.ar/" class="mx-2" target="_BLANK">
              <img src="img/portal/ic_sm_insta.svg" />
            </a>
            <a href="https://twitter.com/resimple_ar" class="mx-2" target="_BLANK">
              <img src="img/portal/ic_sm_twitter.svg" />
            </a>
          </div>
        </div>

        <div class="row fs-08">
          <div class="col-sm-6 text-center text-lg-left">
            Contáctenos:
            <a href="mailto:hola@resimple.com.ar?Subject=Contacto%20Web">
              <img src="img/portal/email.png" style="height:14px;margin-top:-3px;" /> hola@resimple.com.ar
            </a> |
            <a href="https://api.whatsapp.com/send?phone=+5491131236803&text=" target="_BLANK">
              <img src="img/portal/whatsapp.png" style="height:14px;margin-top:-3px;" /> WhatsApp
            </a>
            <br />
            <img src="img/portal/mapmarker.png" style="height:14px;margin-top:-3px;" /> Av. Caseros 3392 Piso 2 Oficina A, (1263) C.A.B.A., Argentina
          </div>
          <div class="col-sm-6 text-center text-lg-right my-4 my-lg-0 nowrap">
            <a href="https://www.resimple.com.ar/legales">Términos y condiciones</a> |
            <a href="https://www.resimple.com.ar/faq/">Preguntas Frecuentes</a>
            <br />2019 © Todos los derechos reservados - Resimple S.A.
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>    

<style scoped src="@/assets/css/site.css">
</style>

<style>

@import "https://fonts.googleapis.com/css?family=Roboto:300,400&display=swap";
@import "https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap";

#selectMotivos option {
  color: #666;
}

@media (max-width: 767.98px) {
  .navbar-collapse {
    -webkit-transition: all 5s ease-in-out;
    -moz-transition: all 5s ease-in-out;
    -ms-transition: all 5s ease-in-out;
    transition: all 5s ease-in-out;
  }

  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    margin: 0;
    margin-top: 56px;
    width: 100%;
    box-shadow: none !important;
    border-radius: 0 !important;
    font-family: "Roboto", sans-serif !important;
    font-size: 16px !important;
    color: #606060 !important;
    padding-left: 21 !important;
    padding-right: 21 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .navbar-collapse.collapsing,
  .navbar-collapse.show .nav-link {
    color: #606060 !important;
  }

  .navbar-collapse.collapsing,
  .navbar-collapse.show .nav-item.link-comerciante .nav-link {
    color: rgb(255, 73, 64) !important;
  }

  .navbar-collapse.collapsing,
  .navbar-collapse.show .nav-item .btn-primary.nav-link {
    color: white !important;
  }
}
</style>

<script>
import $ from "jquery";

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";

export default {
  name: "portal-layout",
  components: { KitsCombo },
  computed: {
    navBarClass() {
      if (this.showNavBar) {
        return "show";
      }
      return "";
    }
  },
  data() {
    return {
      motivos: [],
      MotivoID: null,
      Name: "",
      Body: "",
      Mail: "",
      showNavBar: false
    };
  },
  mounted: function() {
    // Collapse Navbar
    var navbarCollapse = function() {
      if ($("#mainNav").offset().top > 100) {
        $("#mainNav").addClass("navbar-scrolled");
      } else {
        $("#mainNav").removeClass("navbar-scrolled");
      }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

    var topMenuHeight = $("#mainNav").outerHeight() + 1;
  },
  beforeMount: function() {
    // let context = this;
    // axiosHelpers.axiosGet("ContactReason/GetAll", {}, this, function(data) {
    //   context.motivos = data.ResponseVM;
    // });
  },
  methods: {
    toggleNavBar() {
      this.showNavBar = !this.showNavBar;
    },
    enviarContacto() {
      let context = this;
      if (
        this.Name == "" ||
        this.Body == "" ||
        this.Mail == "" ||
        this.MotivoID == null
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Complete todos los campos",
          context
        );
        return;
      }

      axiosHelpers.axiosPost(
        "ContactReason/SendContactMail",
        {
          Name: this.Name,
          Body: this.Body,
          Mail: this.Mail,
          ReasonID: this.MotivoID
        },
        context,
        function(data) {
          if (data.ResponseVM.Result) {
            notificationHelpers.showSuccess(
              "Exito",
              "Nos pondremos en contacto a la breveadad",
              context
            );

            context.Name = "";
            context.Body = "";
            context.Mail = "";
          }
        }
      );
    }
  }
};
</script>
<style>
</style>